module.exports = __webpack_public_path__ + "ff43ae1a6e9ae6bc9faa02b76230f3a0.png";